import AWSIcon from '../../../images/AWSIcon.png'
import JavaIcon from '../../../images/JavaIcon.png'
import MongoIcon from '../../../images/MongoIcon.png'
import ReactIcon from '../../../images/ReactIcon.png'
import SpringIcon from '../../../images/SpringIcon.png'
import JavaScriptIcon from '../../../images/JavaScriptIcon.png'

const TechnologiesUsed
 = () => {
    return (
        <>
            <section id="Technologies Used" className="ds-section">
            <div className="ds-section-header">
            <h2 className="ds-title">Technologies Used</h2>
           
                        
            <div className="ds-description">
                <br/>
                Backend:
            <div id="w-node-acfb0cfc-423c-6793-641c-9f45e3b8d323-e3b8d21ac" className=" quick-stack-8about wf-layout-layout">
            
                <div id="w-node-_7353c4b0-05c9-aef4-9829-6b9a74915ea4-781602bdabout" className="w-layout-layoutabout quick-stack-6 wf-layout-layout">
                    <div id="w-node-_7353c4b0-05c9-aef4-9829-6b9a74915ea5-781602bd" className="w-layout-cellabout ">
                        
                        
                        <img src={JavaIcon} loading="lazy" style={{"maxHeight": "160px"}}/>
                    </div>
                    <div className="w-layout-cellaboutSpring spring">
                        <img src={SpringIcon} loading="lazy" style={{"maxHeight": "160px"}}/>

                    </div>
                    <div className="w-layout-cellabout">
                        <img src={MongoIcon} loading="lazy" style={{"maxHeight": "160px"}}/>
                    </div>
                </div>
            Frontend:
                <div id="w-node-_7353c4b0-05c9-aef4-9829-6b9a74915ea4-781602bdabout" className="w-layout-layoutabout quick-stack-6 wf-layout-layout"> 
                    <div id="w-node-_7353c4b0-05c9-aef4-9829-6b9a74915ea5-781602bd" className="w-layout-cellabout ">
                        
                        <img src={JavaScriptIcon} loading="lazy" style={{"maxHeight": "160px", "height": "70%"}}/>
                    </div>
                    <div className="w-layout-cellabout">
                    <img src={ReactIcon} loading="lazy" style={{"maxHeight": "160px"}}/>
                    </div>
                    <div id="w-node-_7353c4b0-05c9-aef4-9829-6b9a74915ea5-781602bd" className="w-layout-cellabout ">
                        
                    </div>
                </div>

      
            
            Deployment:
            <div id="w-node-_7353c4b0-05c9-aef4-9829-6b9a74915ea4-781602bdabout" className="w-layout-layoutabout quick-stack-6 wf-layout-layout"> 
                <div id="w-node-_7353c4b0-05c9-aef4-9829-6b9a74915ea5-781602bdabout" className="w-layout-cellabout">
                    
                    <img src={AWSIcon} loading="lazy" style={{"maxHeight": "160px"}}/>
                </div>
                </div>
            </div>
            </div>
            </div>
            </section>
        </>
    );
};

export default TechnologiesUsed
;
